import { createRouter, createWebHistory } from 'vue-router'
import PasswordForm from '../components/PasswordForm.vue'
import UnlockSecret from '../components/UnlockPassword.vue'
import UserLogin from '../components/UserLogin.vue'
import AuthCallback from '../components/AuthCallback.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: PasswordForm
  },
  {
    path: '/unlock/:code',
    name: 'Unlock',
    component: UnlockSecret
  },
  {
    path: '/login',
    name: 'Login',
    component: UserLogin
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallback
  }
]

const router = createRouter({

  history: createWebHistory(process.env.BASE_URL || '/'),
  routes
})
export default router